const DatePickerLocales_ko = {
     name: "DatePickerLocales_ko",
     months: [
          ["1월", "1월"],
          ["2월", "2월"],
          ["3월", "3월"],
          ["4월", "4월"],
          ["5월", "5월"],
          ["6월", "6월"],
          ["7월", "7월"],
          ["8월", "8월"],
          ["9월", "9월"],
          ["10월", "10월"],
          ["11월", "11월"],
          ["12월", "12월"],
     ],
     weekDays: [
          ["토", "토"],
          ["일", "일"],
          ["월", "월"],
          ["화", "화"],
          ["수", "수"],
          ["목", "목"],
          ["금", "금"],
     ],
     digits: ["0", "1", "2", "3", "4", "5", "6", "7", "8", "9"],
     meridiems: [
          ["오전", "오전"],
          ["오후", "오후"],
     ],
};

export default DatePickerLocales_ko;
